import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import './form-item.scss';

const FormItem = (props) => {
  const {
    id,
    name,
    type,
    className,
    required = false,
    labelHidden = false,
    labelProps,
    sublabel,
    children,
    ...restProps
  } = props;

  const { className: labelClasses, ...restLabel } = labelProps || {};

  return (
    <div
      className={clsx(
        'form-item',
        type && `form-item--${type}`,
        className,
      )}
      {...restProps}
    >
      <label
        className={clsx(
          'form-item__label',
          required && 'form-item__label--required',
          labelHidden && 'visually-hidden',
          labelClasses,
        )}
        htmlFor={id}
        {...restLabel}
      >
        {name}
        {required && (
          <span className="required">*</span>
        )}
      </label>
      {sublabel && (
        <div className="form-item__sublabel">{sublabel}</div>
      )}
      {children}
    </div>
  );
};

FormItem.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool,
  labelHidden: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
  ]).isRequired,
};

export default FormItem;
